export { default as AiSummarySecondaryIcon } from "./ai-summary-secondary-icon";
